<template>
  <div id="modalPagamento" class="modal-pagamento" v-show="opened">
    <div class="modal-pagamento-content">
      <div class="py-4 py-md-3 bg-white shadow-sm">
        <div class="container text-center position-relative">
          <a href="javascript:" class="btn btn-outline-light position-absolute" style="left: 12px; top: -7px; border-radius: 50%" aria-label="Voltar" @click="closeModal()">
            <i class="fa fa-chevron-left text-dark"></i>
          </a>
          <h1 class="h6 font-weight-bold m-auto">PAGAMENTO</h1>
        </div>
      </div>
      <div style="height: 100%" v-if="load">
        <loading fullscrean="true" :text="text"/>
      </div>
      <div v-show="!load">
        <div v-show="menu === 1">
          <div class="container container-endereco py-3">
            <div class="text-center">
              <div class="card p-3 mb-3 text-left">
                <h6 class="font-weight-bold">Valor a pagar: {{pedido.valor_total | valor}}</h6>
                <div>1. Acesse seu Internet Banking ou app de pagamentos</div>
                <div>2. Escolha pagar via Pix Copia e Cola</div>
                <div>3. Copie e cole o código pix abaixo:</div>
                <div class="mt-2">
                  <div class="d-flex justify-content-between mb-1">
                    <input class="form-control mr-2" id="chavePix" :value="dadosPix.qr_code">
                    <button class="btn btn-primary btn-block" style="width: 90px" @click="copiarChave">Copiar</button>
                  </div>
                </div>
              </div>
              <div>
                Você também pode pagar scaneando este qr code:
                <div v-if="dadosPix.qr_base64">
                  <img :src="`data:image/jpeg;base64,${dadosPix.qr_base64}`" alt="QrCode Pix" style="max-width: 170px">
                </div>
                <div v-if="dadosPix.qr_link">
                  <img :src="`${dadosPix.qr_link}`" alt="QrCode Pix" style="max-width: 170px">
                </div>
              </div>
              <div>
                Código válido por: {{tempoPagamento}}<span v-show="!tempoPagamento">10:00</span> minutos
              </div>
              <hr>
              <div class="small">
                Já realizou o pagamento? <a href="javascript:" @click="recarregarPagina()">Clique aqui</a> para atualizar.
              </div>
            </div>
          </div>
        </div>

        <div v-show="menu === 2">
          <div class="container container-endereco py-3">
            <div class="alert alert-info small">
              Por exigência do Banco Central, é necessário informar um documento para geração de pagamentos online.
            </div>
            <div class="card p-3 mb-2">
              <form @submit.prevent="validarDados">
                <div class="form-group mb-2">
                  <label class="mb-0 font-weight-bold">Informe seu CPF *</label>
                  <the-mask id="cpf" type="tel" :mask="['###.###.###-##']" class="form-control" v-model="dados.cpf" placeholder="###.###.###-##" required/>
                  <div class="small text-muted mt-1">Usado apenas para gerar o pagamento</div>
                </div>
                <button class="btn btn-primary btn-block mt-3" :disabled="dados.cpf.length < 11">
                  Gerar Pagamento
                </button>
              </form>
            </div>
            <div class="my-3 text-muted">
              <div class="small">Concordo com os <a href="https://lecard.delivery/termos-de-uso/" target="_blank" class="text-primary font-weight-bold">Termos e Condições de uso!</a></div>
              <div class="small">Estou enviando informações verdadeiras podendo responder civilmente perante a lei.</div>
            </div>
          </div>
        </div>

        <div v-show="menu === 3">
          <div class="container container-endereco py-3">
            <div class="text-center">
              <div class="card p-3 mb-4 text-left">
                <h6 class="font-weight-bold mb-2">Valor a pagar: {{pedido.valor_total | valor}}</h6>
                <div class="mb-1">Siga o passo a passo:</div>
                <div>1. Clique no botão "Realizar Pagamento"</div>
                <div>2. Selecione uma forma de pagamento</div>
                <div>3. Informe seus dados</div>
                <div>3. Pronto! Seu pedido será aprovado automaticamente</div>
              </div>
              <a :href="linkPagamento" @click="pagamentoAberto = true" target="_blank" class="btn btn-primary btn-block" v-if="linkPagamento">
                Realizar Pagamento
              </a>
              <button @click="abrirPagamento()" class="btn btn-primary btn-block" v-else>
                Realizar Pagamento
              </button>
              <div class="mt-3">
                Você tem <b>{{ tempoPagamento }}</b> minutos para realizar seu pagamento.
              </div>
              <hr>
              <div class="small" v-show="pagamentoAberto">
                Já realizou o pagamento? <a href="javascript:" @click="recarregarPagina()">Clique aqui</a> para atualizar.
              </div>
            </div>
          </div>
        </div>

        <div v-if="menu === 4">
          <cartoes-pagarme @selecionarCartao="selecionarCartaoPagarme"/>
        </div>

        <div v-if="menu === 5">
          <cartoes-mercadopago @atualizar="closeModal" :pedido="pedido" :dados="dados"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Icon from "./Icon";
  import Loading from "./Loading";
  import CardInfo from "./CardInfo";
  import {TheMask} from 'vue-the-mask';
  import CartoesMercadopago from "./CartoesMercadoPago";
  import CartoesPagarme from "./CartoesPagarme";

  export default {
    name: "PixPagamento",
    components: {CartoesPagarme, CartoesMercadopago, CardInfo, Loading, Icon, TheMask},

    data() {
      return {
        opened: false,
        token: localStorage.getItem('token'),
        load: true,
        chavePix: [],
        pedido: {},
        dadosPix: {
          qr_base64: '',
          qr_code: '',
          qr_link: ''
        },
        linkPagamento: null,
        menu: 1,

        dados: {
          id_pedido: "",
          cpf: "",
          id_pagamento: ""
        },

        text: 'Gerando pagamento..',
        tempoPagamento: null,
        countDown: '',
        wasCopied: false,
        pagamentoAberto: false
      }
    },

    methods: {
      getQrCode() {
        this.load = true;
        this.menu = 1;
        const id_pedido = this.dados.id_pedido;

        this.$http.post(this.pedido.token + '/' + this.token + '/pix-mercado-pago', this.dados)
          .then(response => {
            if (response.data && response.data.result) {
              this.dadosPix = response.data;
              this.load = false;

            } else {
              this.$swal("Não conseguimos processar o QrCode de pagamento. Por favor tente novamente. Pedido: " + id_pedido);
              this.closeModal();
            }

          }, res => {
            const msg = res.data ? res.data.msg : null;
            this.$swal("Não conseguimos processar o QrCode de pagamento. Pedido: " + id_pedido + (msg ? "\nErro: " + msg : ""));
            this.closeModal();
            // this.load = false;
          });
      },

      getPreference() {
        this.load = true;
        this.menu = 3;

        if (sessionStorage.getItem("linkpag" + this.dados.id_pedido)) {
          this.linkPagamento = sessionStorage.getItem("linkpag" + this.dados.id_pedido);
          this.load = false;
          return;
        }

        this.dados.back_url = location.href;
        const id_pedido = this.dados.id_pedido;

        this.$http.post(this.pedido.token + '/' + this.token + '/preference-mercado-pago',  this.dados)
          .then(response => {
            if (response.data && response.data.result) {
              this.load = false;
              this.linkPagamento = response.data.link;
              sessionStorage.setItem("linkpag" + id_pedido, this.linkPagamento);

            } else {
              this.$swal("Não conseguimos processar seu pagamento. Por favor tente novamente. Pedido: " + id_pedido);
            }

          }, res => {
            const msg = res.data ? res.data.msg : null;
            this.$swal("Não conseguimos processar seu pagamento. Pedido: " + id_pedido + (msg ? "\nErro: " + msg : ""));
            // this.load = false;
          });
      },

      validarDados() {
        if (this.dados.cpf || this.usuario.cpf) {
          this.dados.cpf = this.dados.cpf ? this.dados.cpf : this.usuario.cpf;
        }

        if (!this.dados.cpf) {
          this.load = false;
          this.menu = 2;
          this.$swal("Por exigência do Banco Central, é necessário que informe seu CPF para que seja gerado seu pagamento online!").then(() => {
            this.$helpers.focusrElement("cpf");
          });

          return;

        } else if (!this.$helpers.validarCpf(this.dados.cpf)){
          this.load = false;
          this.menu = 2;
          this.$swal("Por favor informe um CPF válido").then(() => {
            this.$helpers.focusrElement("cpf")
          });
          return;
        }

        this.$store.state.dataUser.cpf = this.dados.cpf;
        this.dados.id_pedido = this.pedido.id_pedido;
        this.dados.origin = this.origin;

        if (this.pedido.id_pagamento === '15') {
          this.getQrCode();

        } else if (this.pedido.id_pagamento === '30'){
          this.pagamentoCartaoPagarme();

        } else if (this.pedido.id_pagamento === '31'){
          this.pagamentoQrcodePagarme();

        } else if (this.pedido.id_pagamento === '32') {
          this.pagamentoCartaoMP();

        } else {
          this.getPreference();
        }
      },

      pagamentoCartaoMP(){
        this.load = false;
        this.menu = 5;
        this.dados.id_pagamento = this.pedido.id_pagamento;
      },

      pagamentoCartaoPagarme(){
        this.load = false;
        this.menu = 4;
        this.dados.back_url = location.href;
        this.dados.id_pagamento = this.pedido.id_pagamento;
      },

      copiarChave() {
        this.wasCopied = true;
        const copyText = document.getElementById('chavePix');
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        this.$swal("Código copiado","Falta pouco! Agora é só colar o código em seu Internet Banking. A confirmação é automática!");
      },

      abrirPagamento() {
        this.$swal({
          text: 'Deseja abrir a tela de pagamento novamente?',
          buttons: ["Não", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            window.open(this.linkPagamento, '_target')
          }
        });
      },

      infoPix() {
        this.$swal("Após realizar o pedido você tem 30 minutos para enviar o pagamento. Entre em contato por telefone se precisar estornar o valor pago.");
      },

      closeModal(atualizar) {
        clearInterval(this.countDown);
        document.body.classList.remove("modal-open");
        this.opened = false;
        this.menu = 1;

        if (atualizar) {
          this.$emit('atualizar');
        }
      },

      recarregarPagina() {
        this.closeModal();
        this.$emit('confirmar', this.dadosPix.codigo_externo, this.dados.id_pedido);
      },

      selecionarCartaoPagarme(id_cartao){
        this.text = "Realizando pagamento..";
        this.load = true;
        this.dados.id_cartao = id_cartao;
        this.$http.post(this.pedido.token + '/' + this.token + '/pagarme/pagamento', this.dados)
          .then(response => {
            this.load = false;

            if (response.data) {
              if (response.data.status_pagamento === 'paid') {
                this.pagamentoAberto = true
                this.closeModal(true);
                this.$swal("O pagamento foi realizado com sucesso.");

              } else if (response.data.status_pagamento === 'pending') {
                this.$swal("Estamos aguardando a confirmação de pagamento, você será redirecionado para a tela de pedidos.").then(() => {
                  this.pagamentoAberto = true
                  this.closeModal(true);
                });
              }

              return;
            }

            this.$swal("O pagamento foi recusado, tente novamente.");

          }, res => {
            this.load = false;
            const msg = res.data ? res.data.msg : null;
            this.$swal("Não conseguimos processar seu pagamento via cartao. Pedido: " + this.dados.id_pedido + (msg ? "\nErro: " + msg : ""));            
          });
      },

      pagamentoQrcodePagarme() {
        this.load = false;
        this.menu = 1;

        this.$http.post(this.pedido.token + '/' + this.token + '/pagarme/pagamento',  this.dados)
          .then(response => {
            this.load = false;

            if (response.data.status_pagamento == 'failed') {
              this.$swal("Não foi possível gerar o Qr Code. Contato um adminstrador para mais informações!").then(() => {
                this.pagamentoAberto = true
                this.closeModal(true);
              });

            } else {
              this.dadosPix.qr_link = response.data.qr_link;
              this.dadosPix.qr_code = response.data.qr_code;
            }

          }, res => {
            this.load = false;
            const msg = res.data ? res.data.msg : null;
            this.$swal("Não conseguimos processar seu pagamento via PIX. Pedido: " + this.dados.id_pedido + (msg ? "\nErro: " + msg : ""));
          });
      },
    },

    computed: {
      zap() {
        return this.$store.state.zap
      },

      usuario() {
        return this.$store.state.dataUser
      },
    },

    created() {      
      this.$parent.$on('openModalPix', (p) => {
        if (this.$route.query.payment_id) {
          return;
        }

        this.text = "Gerando pagamento..";
        this.pedido = p;
        document.body.classList.add("modal-open");
        this.opened = true;
        this.tempoPagamento = null;
        this.menu = 1;

        if (this.pedido.previsao_pagamento < 0) {
          this.closeModal(true);

        } else {
          this.validarDados(this.pedido);
          let timer = this.pedido.previsao_pagamento, minutes, seconds;

          if (this.pedido.previsao_pagamento) {
            this.countDown = setInterval(() => {
              minutes = parseInt(timer / 60, 10);
              seconds = parseInt(timer % 60, 10);

              minutes = minutes < 10 ? "0" + minutes : minutes;
              seconds = seconds < 10 ? "0" + seconds : seconds;

              this.tempoPagamento = minutes + ":" + seconds;

              if (--timer < 0) {
                this.closeModal(true);
              }
            }, 1000);
          }
        }
      });

      this.$parent.$on('closeModalPix', () => {
        if (this.opened) {
          this.closeModal();
        }
      });
    },

    beforeDestroy() {
      clearInterval(this.countDown);
    }
  }
</script>

<style scoped>
  .modal-pagamento {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1060; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  .modal-pagamento-content {
    background-color: #fefefe;
    margin: 8vh auto 12vh;
    width: 600px;
    height: 80vh;
    position: relative;
    border-radius: 6px;
    overflow: hidden;
  }

  .container-endereco {
    padding-bottom: 90px;
  }

  @media (max-width: 767px) {
    .modal-pagamento-content {
      overflow: auto;
      min-height: 100%;
      height: 100vh;
      width: 100%;
      margin: 0;
      border-radius: 0;
    }
  }

  @media (min-width: 768px) {
    .container-endereco {
      overflow: auto;
      height: calc(80vh - 50px);
    }
  }
</style>
